'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface CoverageArea {
  name: string;
  zone: string;
  basePrice: string;
  description: string;
}

const CoverageMap = () => {
  const [selectedZone, setSelectedZone] = useState<string>('all');

  const coverageAreas: CoverageArea[] = [
    {
      name: 'Farwaniya Central',
      zone: 'Zone A',
      basePrice: '45',
      description: 'Our primary service area with fastest response times',
    },
    {
      name: 'Andalous',
      zone: 'Zone A',
      basePrice: '45',
      description: 'Full-service coverage with same-day availability',
    },
    {
      name: 'Jleeb Al-Shuyoukh',
      zone: 'Zone A',
      basePrice: '45',
      description: 'Comprehensive moving services for residential areas',
    },
    {
      name: 'Khaitan',
      zone: 'Zone B',
      basePrice: '55',
      description: 'Extended coverage with 24-hour advance booking',
    },
    {
      name: 'Abraq Khaitan',
      zone: 'Zone B',
      basePrice: '55',
      description: 'Professional service for apartments and villas',
    },
    {
      name: 'Ardiya',
      zone: 'Zone B',
      basePrice: '55',
      description: 'Industrial and commercial moving specialists',
    },
    {
      name: 'Salmiya',
      zone: 'Zone C',
      basePrice: '65',
      description: 'Premium service for coastal residential areas',
    },
    {
      name: 'Hawally',
      zone: 'Zone C',
      basePrice: '65',
      description: 'Full-service moving for urban apartments',
    },
    {
      name: 'Kuwait City',
      zone: 'Zone C',
      basePrice: '70',
      description: 'Downtown commercial and residential services',
    },
  ];

  const filteredAreas =
    selectedZone === 'all'
      ? coverageAreas
      : coverageAreas.filter((area) => area.zone === selectedZone);

  const zones = ['all', 'Zone A', 'Zone B', 'Zone C'];

  return (
    <div className="bg-card rounded-lg shadow-soft overflow-hidden">
      <div className="bg-secondary p-6">
        <h2 className="text-2xl font-headline font-bold text-secondary-foreground">
          Service Coverage Areas
        </h2>
        <p className="text-secondary-foreground/80 mt-2">
          Farwaniya and Greater Kuwait with transparent zone pricing
        </p>
      </div>

      <div className="p-6">
        <div className="flex flex-wrap gap-2 mb-6">
          {zones.map((zone) => (
            <button
              key={zone}
              onClick={() => setSelectedZone(zone)}
              className={`px-4 py-2 rounded-lg font-body font-medium transition-all duration-base ${
                selectedZone === zone
                  ? 'bg-brand-purple text-white' :'bg-muted text-text-primary hover:bg-muted/80'
              }`}
            >
              {zone === 'all' ? 'All Areas' : zone}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {filteredAreas.map((area) => (
            <div
              key={area.name}
              className="border border-border rounded-lg p-4 hover:border-brand-purple transition-colors duration-base"
            >
              <div className="flex items-start justify-between mb-2">
                <div>
                  <h3 className="font-headline font-bold text-primary">
                    {area.name}
                  </h3>
                  <span className="inline-block mt-1 px-2 py-1 bg-muted rounded text-xs font-semibold text-text-secondary">
                    {area.zone}
                  </span>
                </div>
                <Icon
                  name="MapPinIcon"
                  size={24}
                  variant="solid"
                  className="text-brand-purple"
                />
              </div>
              <p className="text-sm text-text-secondary mb-3">
                {area.description}
              </p>
              <div className="flex items-baseline">
                <span className="text-sm text-text-secondary">From</span>
                <span className="text-xl font-headline font-bold text-brand-purple ml-2">
                  {area.basePrice}
                </span>
                <span className="text-sm text-text-secondary ml-1">KWD</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 p-4 bg-muted rounded-lg">
          <div className="flex items-start space-x-3">
            <Icon
              name="InformationCircleIcon"
              size={24}
              variant="solid"
              className="text-brand-ocean flex-shrink-0 mt-0.5"
            />
            <div>
              <p className="text-sm text-text-primary">
                <strong>Zone Pricing:</strong> Base prices shown are starting
                rates for standard residential moves. Final pricing depends on
                distance, volume, and additional services. Get an instant quote
                for accurate pricing.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="p-6 bg-background border-t border-border">
        <div className="aspect-video w-full rounded-lg overflow-hidden">
          <iframe
            width="100%"
            height="100%"
            loading="lazy"
            title="Almanara Moving Service Coverage Map - Farwaniya Kuwait"
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps?q=29.2775,47.9580&z=12&output=embed"
            className="border-0"
          />
        </div>
      </div>
    </div>
  );
};

export default CoverageMap;